import React from 'react'
import { useDiagramDocument } from '../../../contexts/DiagramDocumentContext'
import { useDiagramInfo } from '../../../hooks/useDiagramInfo'
import { useProcessFolderConfig } from '../folders/useProcessFolderConfig'
import { useProcessCanvasLayerStore } from './processCanvasLayerStore'

/**
 * Resolves the open diagram's folder and mirrors the Compliance layer
 * state into `useProcessCanvasLayerStore`, so canvas GRC overlays can
 * gate on it. Renders nothing. Mount once in the editor shell.
 *
 * Only *process* folders gate: when the folder is a process kind, the
 * Compliance layer follows `tracksCompliance`. Any other domain (or an
 * unresolved folder) leaves the overlay active — network/cloud diagrams
 * that reuse GrcBadges are unaffected. See docs/product/process-user-journey.md.
 */
export const ProcessCanvasLayerSync: React.FC = () => {
  const { diagramId } = useDiagramDocument()
  const { data: diagramInfo } = useDiagramInfo(diagramId)
  const folderId = diagramInfo?.folderId ?? null
  const folderConfig = useProcessFolderConfig(folderId)
  const setComplianceActive = useProcessCanvasLayerStore((s) => s.setComplianceActive)

  React.useEffect(() => {
    const data = folderConfig.data
    // Until the folder resolves, keep overlays active (no flash-hide for
    // non-process diagrams). Only a confirmed process folder may gate.
    if (data && data.domain === 'process') {
      setComplianceActive(Boolean(data.config.tracksCompliance))
    } else {
      setComplianceActive(true)
    }
  }, [folderConfig.data, setComplianceActive])

  return null
}
